<ul class="navbar-nav ms-auto">
	@if (isAdminOrSystem) {
		<li class="nav-item d-inline d-lg-none">
			<a class="nav-link disabled" routerLinkActive="active" href="javascript:void(0)">Engagements</a>
		</li>
		<li class="nav-item d-inline d-lg-none ps-5">
			<a class="nav-link" [routerLink]="['/engagements', 'dashboard']" routerLinkActive="active">Dashboard</a>
		</li>
		<li class="nav-item d-inline d-lg-none ps-5">
			<a class="nav-link" [routerLink]="['/engagements', 'overview']" routerLinkActive="active">Events View</a>
		</li>
		<li class="nav-item d-inline d-lg-none ps-5">
			<a class="nav-link" [routerLink]="['/engagements', 'smart-engage']" routerLinkActive="active">Smart Engage</a>
		</li>
		<li class="nav-item d-inline d-lg-none ps-5">
			<a class="nav-link" [routerLink]="['/engagements', 'triggers']" routerLinkActive="active">Triggers</a>
		</li>
		<li class="nav-item d-inline d-lg-none ps-5">
			<a class="nav-link" [routerLink]="['/engagements', 'queries']" routerLinkActive="active">Queries</a>
		</li>
		<li class="nav-item d-inline d-lg-none ps-5 mb-3">
			<a class="nav-link disabled" [routerLink]="['/engagements', 'data-sources']" routerLinkActive="active">Data Sources</a>
		</li>
	} @else {
		<li class="nav-item d-inline d-lg-none mb-3">
			<a ngbDropdownItem [routerLink]="['/engagements', 'overview']" routerLinkActive="active">Engagements</a>
			<ul ngbDropdownMenu>
				<li class="mb-3"><a ngbDropdownItem [routerLink]="['/engagements', 'dashboard']" routerLinkActive="active">Dashboard</a></li>
				<li class="mb-3"><a ngbDropdownItem [routerLink]="['/engagements', 'overview']" routerLinkActive="active">Events View</a></li>
				<li class="mb-3"><a ngbDropdownItem [routerLink]="['/engagements', 'smart-engage']" routerLinkActive="active">Smart Engage</a></li>
			</ul>
		</li>
	}
	<li class="nav-item d-inline d-lg-none mb-4">
		<a class="nav-link disabled" routerLinkActive="active" href="javascript:void(0)">Emails</a>
	</li>
	@if (isAdminOrSystem) {
		<li class="nav-item">
			<a class="nav-link" [routerLink]="['admin']" routerLinkActive="active"
				><fa-icon [icon]="['fas', 'gears']" [fixedWidth]="true"></fa-icon>Admin</a
			>
		</li>
	}
	<li class="nav-item">
		<a class="nav-link" href="javascript:void(0)"><fa-icon [icon]="['fas', 'circle-question']"></fa-icon>Support</a>
	</li>
	<li class="nav-item">
		<a class="nav-link" [routerLink]="['user']" routerLinkActive="active"><fa-icon [icon]="['fas', 'user']" [fixedWidth]="true"></fa-icon>Account</a>
	</li>
	<li class="nav-item">
		<a class="nav-link" ngbDropdownItem (click)="logout()" href="javascript:void(0)">
			<fa-icon [icon]="['fas', 'arrow-right-from-bracket']" [fixedWidth]="true"></fa-icon>Logout</a
		>
	</li>
</ul>
